import { ExternalSourceUrlActionKey } from "../../actions/ActionKeys";
import { ExternalSourceUrlAction } from "../../actions/externalSourceUrl";

export function externalSourceUrl(
  state: string | null = null,
  action: ExternalSourceUrlAction
): string | null {
  switch (action.type) {
    case ExternalSourceUrlActionKey.SET_EXTERNAL_SOURCE_URL:
      return action.payload.externalSourceUrl;
    default:
      return state;
  }
}
